module.exports = __webpack_public_path__ + "media/images/icon/success-de4ee7ad58f75b356c97fa17653567c7.svg";